import classNames from 'classnames';
import React from 'react';
import { ReactComponent as Stars2 } from 'src/assets/icons/star-animation-1.svg';
import { ReactComponent as Stars1 } from 'src/assets/icons/star-animation-2.svg';
import { ReactComponent as Stars3 } from 'src/assets/icons/star-animation-3.svg';
import { ReactComponent as StarsLarge2 } from 'src/assets/icons/star-animation-large-1.svg';
import { ReactComponent as StarsLarge1 } from 'src/assets/icons/star-animation-large-2.svg';
import { ReactComponent as StarsLarge3 } from 'src/assets/icons/star-animation-large-3.svg';

interface Props {
  loading?: boolean;
  starsWhite?: boolean;
  extraContainerClass?: string;
  size?: 'default' | 'large';
  disabled?: boolean;
}

const AiStartAnimation: React.FC<Props> = ({
  starsWhite,
  extraContainerClass,
  size = 'default',
  disabled,
}) => {
  return (
    <div
      className={classNames(
        'ai-star-animation',
        starsWhite && 'ai-animation-stars-white',
        disabled && 'ai-animation-stars-disabled',
        extraContainerClass,
      )}
    >
      {size === 'default' && (
        <>
          <Stars1 className="animated-image" />
          <Stars2 className="animated-image" />
          <Stars3 className="animated-image" />
        </>
      )}

      {size === 'large' && (
        <>
          <StarsLarge1 className="animated-image" />
          <StarsLarge2 className="animated-image" />
          <StarsLarge3 className="animated-image" />
        </>
      )}
    </div>
  );
};

export default AiStartAnimation;
